export { Company } from './Company.js';
export type { CompanyProps } from './Company.type.js';
